import {Page} from "../../components/common";
import {Trans, useTranslation} from "react-i18next";
import {useClient} from "../../hooks";
import {useMutation} from "react-query";
import {useEffect} from "react";
import {useQueryParams} from "./useQueryParams";
import {Alert} from "reactstrap";
import {Link} from "react-router-dom";

export const ZidOAuthCallback = () => {
  const { t } = useTranslation();
  const client = useClient();
  const { code, error } = useQueryParams();

  const { mutate, isSuccess, isError, data, isLoading } = useMutation(async () => {
    if (error) {
      throw Error("An error occurred: " + error);
    }
    return client.post('zid/oauth/authorize', {
      code
    }).get('data')
  }, {
    useErrorBoundary: false
  })
  const { store_title } = data ?? {};

  useEffect(() => mutate(), [mutate]);

  return (
    <Page translate={false} title={t('Zid Connect')}>
      {isLoading ? (
        <>
          <span className="fa fa-spinner fa-spin text-muted mr-2" />
          <Trans>
            Please wait while we authorize with Zid...
          </Trans>
        </>

      ) : null}
      {isSuccess ? (
        <Alert color="success">
          <Trans>
            Successfully authorized with Zid for store '{{ store_title }}'. You may now use this connection in
            {' '}
            <Link to="/wp-connect">WP Connect</Link>
          </Trans>
        </Alert>
      ) : null}
      {isError ? (
        <Alert color="danger">
          <Trans>
            There was a problem authorizing with Zid, <Link to="../oauth">please go back and try again</Link>.
          </Trans>
        </Alert>
      ) : null}
    </Page>
  )
}